import {
    GameEvent, isPlayerAction,
    Projection,
    SharedGameState,
    useGameStore,
} from '@glark-newco/game-library';
import {
    isCrunchTimePayload,
    isPlayTileEvent,
    isRemoveTileEvent,
} from '../SignlinesPayloadTypes';

export interface PlanningAccuracySlice extends SharedGameState {
    correctDuringPlanning?: number;
    crunched?: boolean;
}

export const planningAccuracyProjection: Projection<PlanningAccuracySlice> = {
    name: 'planningAccuracyProjection',
    project: (
        state: PlanningAccuracySlice,
        newEvents: GameEvent[],
    ): Partial<PlanningAccuracySlice> => {

        let correct = state.correctDuringPlanning ?? 0;
        let crunched = state.crunched ?? false;

        newEvents.forEach(ev => {
            if (crunched || !isPlayerAction(ev)) return;
            if (isCrunchTimePayload(ev.payload)) {
                crunched = true;
                return;
            }

            if (isPlayTileEvent(ev.payload)) {
                const p = ev.payload;
                if (p.tileId === p.positionId) correct += 1;
            } else if (isRemoveTileEvent(ev.payload)) {
                const r = ev.payload;
                if (r.tileId === r.positionId) correct -= 1;
            }
        });


        return {
            correctDuringPlanning: correct,
            crunched,
        };
    },
    reset: () => ({
        correctDuringPlanning: 0,
        crunched: false,
    }),
};

export const usePlanningAccuracy = () =>
    useGameStore((s: PlanningAccuracySlice) => (s.correctDuringPlanning) ?? 0);
